import React, { ComponentProps, forwardRef, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { mapLinkToProps } from '@/utils/helpers';
import { MuiButtonBase } from '@/features/shared/material-ui';
import { PortalMenuItem } from '@/features/PortalNavigation/PortalNavigation.interfaces';
import { BlueArrowIcon } from '@/features/shared/Icons';

type InlineMenuItemProps = {
  menu: PortalMenuItem;
  isOpen: boolean;
  hasSubMenu: boolean;
} & ComponentProps<typeof MuiButtonBase>;

export const InlineMenuItem = ({ menu, isOpen, hasSubMenu, ...restProps }: InlineMenuItemProps) => {
  return (
    <MuiButtonBase
      className={clsx('portal-menu', isOpen && 'active')}
      {...mapLinkToProps(menu.navigationItems?.length ? { ...menu.link, href: '' } : menu.link)}
      {...restProps}
    >
      <span>{menu.link?.displayText}</span>
      {hasSubMenu && (
        <BlueArrowIcon
          style={{ marginLeft: '8px', transition: 'all .3s' }}
          direction={isOpen ? 'top' : 'bottom'}
        />
      )}
    </MuiButtonBase>
  );
};
